<template>
  <v-app
      id="funding-view"
      dark>

    <core-toolbar />
    <core-drawer />

    <v-main>
        <router-view />
    </v-main>

  </v-app>
</template>

<script>
export default {
  name: 'FundingView',
  metaInfo () {
    return {
      title: 'Funding'
    }
  },
  mounted() {
    this.$store.state.app.section='funding';
  }

}

</script>

<style>

</style>
